import styled from "@emotion/styled";

import { theme } from "shared/lib/styles";

import { ContentItemHomeV2FlexiUnit } from "scmp-app/components/content/content-item-render/variants/home-v2-flexi-unit";

export const StyledContentItemHomeV2FlexiUnit = styled(ContentItemHomeV2FlexiUnit)``;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  inline-size: 100%;
  padding-block-start: 12px;

  border-block-start: 1px #000000 solid;

  ${theme.breakpoints.only("tablet")} {
    flex-direction: row;
    align-items: flex-start;
  }
`;
